import React, { useState, useEffect, useRef } from "react";
import './createAccount.css';
import { useForm } from 'react-hook-form';
import validationRules from '../../util/validationRules/ValidationRules';
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import { post } from '../../util/axiosConfig/AxiosConfig'
import Loader from '.././../util/preloader/Preloader';
import showAlert from "../alert/Alert";
import axios from "axios";
import { ENV } from '../../util/Env';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';


const CreateAccount = () => {
    const launchDate = moment(localStorage.getItem('launch'), 'DD-MM-YYYY'); // Parse the launch date
    const currentDate = moment(new Date()); // Current date as a moment object
    localStorage.setItem('currentDate', currentDate)
    useEffect(() => {
        window.scrollTo(0, 0);
        const storedCartData = localStorage.getItem('cartData');
        if (storedCartData) {
            setlocalCartData(JSON.parse(storedCartData));
        }

        const storedUserId = localStorage.getItem('userId');
        if (storedUserId) {
            setUserId(JSON.parse(storedUserId));
        }

        // showAlert('Great!', ' User Registered Successfully', 'success', 'Proceed to payment', false,true,activityCallback);
    }, []);

    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [error, setError] = useState("");
    const [localCartData, setlocalCartData] = useState('')

    const [paymentSuccessData, setPaymentSuccessData] = useState([]);
    const [orderResponse, setOrderResponse] = useState(null);
    const [userId, setUserId] = useState('');
    const [userDetails, setUserDetails] = useState('');
    const [agreement, setAgreement] = useState(true)
    const [email, setEmail] = useState('');


    const userDetailsRef = useRef(userDetails);
    const navigate = useNavigate();
    const newlyCreatedUserId = useRef('');
    const baseUrl = ENV.API_URL;

    useEffect(() => {
        console.log('agreement', agreement);
    }, [agreement]);

    function manageOrder(data) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${baseUrl}web/api/v1/lms-web/payment/order/create`, data, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }


    function sentPaymentId(transactionId, orderId, userId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${baseUrl}web/api/v1/lms-web/payment/order/submit?paymentId=${transactionId}&orderId=${orderId}&userId=${userId}`, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }


    const activityCallback = (value) => {
        if (value === true) {
            generateOrder()
        }
        else {
            redirectToLandingpage();
        }
    }
    console.log(typeof localStorage.getItem("launch"), )


    const generateOrder = async () => {
        let orderData;
        if(localStorage.getItem("type") == "Short") {
            console.log(typeof localStorage.getItem("activeOffer"), localCartData.amount, "ppp")
             orderData = {
                "amount": localStorage.getItem("activeOffer") == "null" ? localStorage.getItem("amount") * 100 : localStorage.getItem("offerPrice") * 100,
                "userId": JSON.parse(localStorage.getItem('userId')),
                "courseIdList": [parseInt(localStorage.getItem("unit"))]
            };
        } else {
             orderData = {
                "amount": localCartData.amount * 100,
                "userId": JSON.parse(localStorage.getItem('userId')),
                "coursePlanId": [localCartData.id],
                "courseIdList": [parseInt(localStorage.getItem("unit"))]
            };
        }
       

        try {
            setLoading(true);
            const success = await manageOrder(orderData);
            setOrderResponse(success);
            if (success.status === 'Created') {
                initializeRazorpay(orderData, success.strId);
            }
        } catch (error) {
            console.error('Error generating order:', error);
            setOrderResponse(null);
        } finally {
            setLoading(false);
        }
    };

    // Sent payment id
    const sentPaymentIdToDb = async (transactionId, orderId, userId) => {
        try {
            setLoading(true);
            const success = await sentPaymentId(transactionId, orderId, userId);
            console.log('status:', success);
        } catch (error) {
            console.error('Error sending paymentId to DB:', error);
        } finally {
            setLoading(false);
        }
    };


    {console.log("dates",   (localStorage.getItem('launch')) )}
    {console.log("sss",   moment(new Date()).format('DD-MM-YYYY') )}

    if( (localStorage.getItem('launch'))  >  moment(new Date()).format('DD-MM-YYYY')) {
        // alert('true')
    }

    const initializeRazorpay = (orderData, orderId) => {
        console.log('userId check > ', userId)

        var options = {
            "key": "rzp_test_TNrGNu3qqHz2Vb",
            "amount": orderData.amount,
            "currency": "INR",
            "name": "Finlabs India Pvt. Ltd.",
            "description": "",
            "image": "https://finlabsindia.org/wp-content/uploads/2023/10/logo-1-Copy-3.png",
            "order_id": orderId,
            // "callback_url": "",
            "prefill": {
                "name": "",
                "email": "",
                "contact": ""
            },
            "notes": {
                "address": ""
            },
            "theme": {
                "color": "#3399cc"
            },

            "handler": function (response) {
                setPaymentSuccessData(response.razorpay_payment_id);
                sentPaymentIdToDb(response.razorpay_payment_id, orderId, JSON.parse(localStorage.getItem('userId')));
                {console.log("dates",  moment(new Date()).format('DD-MM-YYYY'))}
                if((localStorage.getItem('type') == 'Short' && localStorage.getItem('launch') != 'Invalid date') && launchDate.isAfter(currentDate)) {
                    showAlert('', `Payment successful! Course will be launched and accessible on 
                        ${localStorage.getItem('launch')}. Use the credentials sent to your email to access the purchased item. Check your inbox to get started!`, 'success', 'Ok', false, false, redirectTo, false, '', '');
                
                } else {
                    showAlert('', 'Payment successful! Use the credentials sent to your email to access the purchased item. Check your inbox to get started!', 'success', 'Ok', false, false, redirectTo, false, '', '');
                }
                
                // setModalShow(true)
                // debouncedSetModalShow(true);
                // console.log('Payment ID:',response.razorpay_payment_id);
                // console.log('Order ID:',response.razorpay_order_id);
                // console.log('Signature ID:',response.razorpay_signature)
            },

            "payment_error": function (error) {
                console.log('Payment error:', error);
            }
        };

        var rzp = new window.Razorpay(options);
        rzp.open();

        rzp.on('payment.failed', function (response) {
            console.log(response.error.code);
            console.log(response.error.description);
            console.log(response.error.source);
            console.log(response.error.step);
            console.log(response.error.reason);
            console.log(response.error.metadata.order_id);
            console.log(response.error.metadata.payment_id);
        });
    };

    const redirectTo = (value) => {
        if (value === true) {
            localStorage.setItem('userId', '');
            redirectToLoginPageRegister();
        }
    }


    const onSubmit = (data) => {
        let Data;
        if(localStorage.getItem("type") == "Short") {
             Data = {
                interventionIds: [
                    1
                ],
                levelId: [
                    1
                ],
                firstName: data.firstName,
                lastName: data.lastName,
                studentEmail: data.email,
                studentMobileNumber: data.mobileNumber,
                selfRegistered: true,
                unitId: localStorage.getItem("unit")
            } 
        } else {
                Data = {
                    interventionIds: [
                    1
                ],
                levelId: [
                    1
                ],
                firstName: data.firstName,
                lastName: data.lastName,
                studentEmail: data.email,
                studentMobileNumber: data.mobileNumber,
                selfRegistered: true,
                planId: localCartData.id,
                unitId: localStorage.getItem("unit")
            }
        }
        
      

        const sendData = async () => {
            try {
                setLoading(true);
                const response = await post('web/api/v1/lms-web/register/register/user', Data);
                if (response.registered == true) {
                    localStorage.setItem('userId', response.userId);
                    newlyCreatedUserId.current = response.userId
                    showAlert('', 'Registration Successful. You will receive an email shortly with details of your registration!', 'success', 'Proceed to payment', false, false, activityCallback, true, 'Cancel', continueShopping);
                    reset();
                } else {
                    showAlert('Abort!', `${response.message}`, 'warning', 'Ok', false, false, '', false, '', '');
                }

                // setSuccessMessage(true)
                // setErrorMessage(false)


            } catch (error) {
                showAlert('Abort!', ' Unable to register user', 'error', 'Ok', false, false, '', false, '', '');
                setLoading(false);
                // setSuccessMessage(false)
                // setErrorMessage(true)
                setError(error.response.data)
                console.error(error, "ll");
            } finally {
                setLoading(false);
            }
        };
        sendData();
    };

    const continueShopping = (value) => {
        if (value === true) {
            showAlert('', 'Do not worry the items you selected have been added to your cart. You can login to your portal anytime and proceed to checkout to complete your purchase', 'success', 'Continue Shopping', false, false, continueShoppingRedirect, false, 'Proceed to checkout', '');
        }
    }
    const continueShoppingRedirect = (value) => {
        if (value === true) {
            navigate(`/Home?id=${newlyCreatedUserId.current}`);
        }
    }


    const redirectToLoginPageRegister = () => {
        window.open(`${process.env.REACT_APP_BENEFICIARY_BASE_URL}beneficiary-app`, '_blank');
    }

    const redirectToLoginPage = () => {
        //Keycloak login page with email id

        // https://<keycloak-server>/realms/<realm>/protocol/openid-connect/auth?client_id=<client-id>&response_type=code&scope=openid&redirect_uri=<redirect-uri>&email=user@example.com

        // https://keyupdate.finlabsindia.org/realms/pms-lms-dev/protocol/openid-connect/auth?client_id=lms_beneficiary_portal&response_type=code&scope=openid&redirect_uri=https://pms.finlabsindia.org/beneficiary-app/&email=user@example.com

        let keycloakUrl = ENV.API_KEY_URL;
        let redirectRealm = ENV.REALM;
        let redirectClientId = ENV.CLIENT;
        let prKey = window.btoa('lms_email');
        let prValue = window.btoa(email);
        let tempKeyUrl = keycloakUrl + 'realms/' + redirectRealm + '/protocol/openid-connect/auth?client_id=' + redirectClientId + '&response_type=code&scope=openid&redirect_uri=' + ENV.BENEFICIARY_BASE_URL + 'beneficiary-app/&' + prKey + '=' + prValue;
        // let encodeUrlValue = decodeURIComponent((window.atob(prKey)));
        // console.log('url', tempKeyUrl, encodeUrlValue, encodeUrlKey);
        window.open(tempKeyUrl, '_blank');



    //     window.onload = function () { 
    //     const urlParams = new URLSearchParams(window.location.search); 
    //     const email = urlParams.get(btoa((encodeURIComponent('email')))); 
    //     let encodeUrlKey = decodeURIComponent((window.atob(email)));
    //     if (encodeUrlKey) { 
    //         document.getElementById("someid").readOnly = true;
    //         document.getElementById('username').value = encodeUrlKey; 
    //     } else {
    //         document.getElementById("someid").readOnly = false;
    //     }
    // };
        // atob(encodedStringAtoB)

        // window.open(`${process.env.REACT_APP_BENEFICIARY_BASE_URL}beneficiary-app`, '_blank');
    }

    const redirectToLandingpage = () => {
        navigate(`/`)
    }

    const handleAgreementChange = (event) => {
        setAgreement(event.target.checked)
    }

    const checkExistingEmail = () => {
        console.log('email', email)
        let Data;
        if(localStorage.getItem("type") == "Short") {
             Data = {
                email: email,
                unitId: localStorage.getItem("unit")
            }
        } else {
             Data = {
                email: email,
                unitId: localStorage.getItem("unit"),
                id: localCartData.id,

            }
        }
        

        const sendData = async () => {
            try {
                setLoading(true);
                const response = await post('web/api/v1/lms-web/register/checkEmail/Add/cart', Data);


                redirectToLoginPage()
                reset();

                // setSuccessMessage(true)
                // setErrorMessage(false)


            } catch (error) {
                let errorMsg;
                if(error.response.data ==  'Exception occur inside API java.lang.Exception: Selected Course already exists in your account.')  {
                    errorMsg = 'Selected Course already exists in your account.'
                } else if (error.response.data == 'Exception occur inside API java.lang.Exception: Please sign in to continue.') {
                    errorMsg = "Email doesn't exist. Please sign up to continue."
                } else {
                    errorMsg = error.response.data;
                }
                showAlert('', `${errorMsg}`, '', 'Ok', false, false, '', false, '', '');
                setLoading(false);
                // setSuccessMessage(false)
                // setErrorMessage(true)
                setError(error.response.data)
                setEmail('')
                console.error(error, "ll");
            } finally {
                setLoading(false);
            }
        };
        sendData();

    }





    return (
        <React.Fragment>
            {loading ? (
                <Loader />
            ) : (
                <>
                    <Header />
                    <div className="create_account_form_main">
                        <div className="container">
                            <div className="form_area">
                                {/* {successMessage ?
                                    <div class="success_msg">
                                        <i class="fa fa-check Checkstyle_body"></i>
                                        User Registered Successfully
                                    </div> : null
                                }
                                {errorMessage ?
                                    <div class="error_msg"><i class="fa fa-times-circle Checkstyle_body"></i>Unable to register user.</div>
                                    : null
                                } */}
                                <h4 className="create_form_heading">Register Your Account</h4>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row">
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <div className="mb-3">
                                                <label htmlFor="idFirstName" className="form-label">First Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="idFirstName"
                                                    aria-describedby="idFirstName"
                                                    placeholder="Enter first name"
                                                    name="firstName"
                                                    {...register('firstName', {
                                                        required: { value: validationRules.firstName.required, message: validationRules.lastName.requiredMsg },
                                                        pattern: {
                                                            value: validationRules.firstName.pattern,
                                                            message: validationRules.firstName.message,
                                                        },
                                                    })}
                                                />

                                                {errors.firstName && (
                                                    <p className="error-message text-danger">{errors.firstName.message}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <div className="mb-3">
                                                <label htmlFor="idLastName" className="form-label">Last Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="idLastName"
                                                    aria-describedby="idLastName"
                                                    placeholder="Enter last name"
                                                    name="lastName"
                                                    {...register('lastName', {
                                                        required: { value: validationRules.lastName.required, message: validationRules.lastName.requiredMsg },
                                                        pattern: {
                                                            value: validationRules.lastName.pattern,
                                                            message: validationRules.lastName.message,
                                                        },
                                                    })}
                                                />
                                                {errors.lastName && (
                                                    <p className="error-message text-danger">{errors.lastName.message}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <div className="mb-3">
                                                <label htmlFor="idEmailID" className="form-label">Email ID</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="idEmailID"
                                                    aria-describedby="idEmailID"
                                                    placeholder="Enter email"
                                                    name="email"
                                                    {...register('email', {
                                                        required: { value: validationRules.email.required, message: validationRules.email.requiredMsg },
                                                        pattern: {
                                                            value: validationRules.email.pattern,
                                                            message: validationRules.email.message,
                                                        },
                                                    })}
                                                />

                                                {errors.email && (
                                                    <p className="error-message text-danger">{errors.email.message}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <div className="mb-3">
                                                <label htmlFor="idMobileNumber" className="form-label">Mobile Number</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="idMobileNumber"
                                                    aria-describedby="idMobileNumber"
                                                    placeholder="Enter mobile number"
                                                    name="mobileNumber"
                                                    maxLength={10}
                                                    {...register('mobileNumber', {
                                                        required: { value: validationRules.mobileNumber.required, message: validationRules.mobileNumber.requiredMsg },
                                                        pattern: {
                                                            value: validationRules.mobileNumber.pattern,
                                                            message: validationRules.mobileNumber.message,
                                                        },
                                                    })}
                                                />
                                                {errors.mobileNumber && (
                                                    <p className="error-message text-danger">{errors.mobileNumber.message}</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                    </div>

                                    <div className="agreement_check_main">
                                        <div className="form-check cstm_form_check_main">
                                            <input className="form-check-input cstm_check_agreement"
                                                type="checkbox"
                                                checked={agreement}
                                                id="agreement"
                                                onChange={handleAgreementChange}
                                            />
                                            <label className="form-check-label" for="agreementt">
                                                By providing your contact info, you agree to receive communications from Finlabs. You can <a href="#"><span className="focus_text">opt-out</span></a> at any time. For details, refer to our <a href="#"><span className="focus_text">Privacy Policy.</span></a>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="signup_btn_area">
                                        <div className="create_account_btn_area">
                                            <button type="submit" className="create_account_btn">Sign Up</button>
                                        </div>
                                        <span className="or">Or</span>
                                        <div className="create_account_btn_area">
                                            <span className="already_registered">Already Registered ?</span>

                                            <div className="row">
                                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                    <div className="mb-3">
                                                        <label htmlFor="idLoginEmailID" className="form-label">Email ID</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="idLoginEmailID"
                                                            aria-describedby="idLoginEmailID"
                                                            placeholder="Enter email"
                                                            name="loginEmail"
                                                            {...register('loginEmail', {
                                                                required: { value: validationRules.loginEmail?.required, message: validationRules.loginEmail?.requiredMsg },
                                                                pattern: {
                                                                    value: validationRules.loginEmail?.pattern,
                                                                    message: validationRules.loginEmail?.message,
                                                                },
                                                            })}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                        />

                                                        {errors.loginEmail && (
                                                            <p className="error-message text-danger">{errors.loginEmail.message}</p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                                            </div>
                                            <button type="submit" className="create_account_btn" onClick={() => checkExistingEmail()}>Login</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </>
            )}
        </React.Fragment>
    )
}

export default CreateAccount;